import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-add-clients',
  templateUrl: './add-clients.component.html',
  styleUrls: ['./add-clients.component.scss']
})
export class AddClientsComponent implements OnInit {
  public activeTheme: any;
  public createIndividual: boolean = false;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private api: ZpDataService) { }

  ngOnInit(): void {
    this.activeTheme = this.themeService.active;
    this.api.getProfessionalInviteTemplate();
  }

  createIndividualClient() {
    this.router.navigate(["/invite-only"]);
  }

  redirectToUploadList() {
    this.router.navigate(["/upload-professionals-list"]);
  }
}
